import { useState, useEffect, Fragment } from "react";
import { useNavigate, Link } from "react-router-dom";
import baseUrl from "../../url/baseUrl";
import CategoriesNews from "./CategoriesNews";
import ReactPaginate from "react-paginate";
import HashLoader from "react-spinners/HashLoader";
import "./News.css";

const News = () => {
  const [news, setNews] = useState([]);
  const [category, setCategory] = useState("Tất cả");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Tin tức";
  });

  useEffect(() => {
    setLoading(true);
    const getNews = async () => {
      try {
        const response = await fetch(baseUrl + "/get-news");
        if (response.status === 404) {
          throw new Error("Không có tin tức");
        }

        if (response.status !== 200) {
          throw new Error("Failed to fetch news.");
        }
        const data = await response.json();
        setLoading(false);
        setNews(data);
      } catch (err) {
        setLoading(false);
        console.log(err);
      }
    };
    getNews();
  }, []);

  const filterHandler = (category) => {
    setCategory(category);
  };

  let filterNews = news;
  // lọc tin tức khi click từ thanh category
  if (category !== "Tất cả") {
    filterNews = news.filter((item) => item.category === category);
  }
  // paginate
  const itemsPerPage = 5;

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const displayedItems = filterNews.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <Fragment>
      <nav aria-label="breadcrumb">
        <ol
          style={{ "--bs-breadcrumb-bg": "#f0f0f0" }}
          className="breadcrumb ps-3 pt-2 pb-3 mb-0 "
        >
          <li className="breadcrumb-item">
            <Link to="/">Trang chủ</Link>
          </li>
          <li className="breadcrumb-item active " aria-current="page">
            News
          </li>
        </ol>
      </nav>

      <h1 className="text-success ms-5 mb-4">News</h1>
      <div className="row d-flex">
        <div className="col-12 col-md-4 col-lg-3">
          <CategoriesNews onFilter={filterHandler} />
        </div>

        <div className="col-12 col-md-8 col-lg-9">
          {/* show news */}
          {loading && (
            <div className="d-flex justify-content-center align-items-center">
              <HashLoader color="#36d7b7" size={80} />
            </div>
          )}
          {displayedItems.map((item) => (
            <div
              style={{ margin: "0 auto" }}
              key={item._id}
              className="row d-flex mb-4 border rounded bg-light"
            >
              <div className="col-12 col-sm-6 col-lg-3">
                <img
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                  src={item.imageAvatar}
                  alt="image"
                />
              </div>
              <div className="col-12 col-sm-6 col-lg-9">
                <h5 className="mt-3">{item.title}</h5>
                <p className="text-muted">{item.shortDesc}</p>

                <button
                  onClick={() => {
                    navigate(`/news/${item._id}`);
                  }}
                  className="btn btn-primary fs-5"
                >
                  View
                </button>
              </div>
            </div>
          ))}

          {/* paginate top */}
          <ReactPaginate
            breakLabel="..."
            previousLabel={"< Previous"}
            nextLabel={"Next >"}
            pageCount={Math.ceil(filterNews.length / itemsPerPage)}
            onPageChange={handlePageChange}
            containerClassName={"pagination"}
            activeClassName={"active"}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
          />
        </div>
      </div>
    </Fragment>
  );
};
export default News;
